import axios from 'axios';
import { isAuthToken } from '../survey-ui/services/authToken';
export function performHttpRequest(method, url, data) {
    const token = localStorage.getItem('token_id');
    let headers = {};
    // Send the session only to our configured API, never to external URLs.
    try {
        const apiOrigin = new URL(process.env.REACT_APP_NODE_API_URL).origin;
        if (new URL(url, process.env.REACT_APP_NODE_API_URL).origin === apiOrigin && isAuthToken(token)) {
            headers.Authorization = `Bearer ${token}`;
        }
    } catch (_) {
        // Axios will report an invalid URL; no credentials should be attached.
    }
    // Use Axios to make the HTTP request
    return axios({
        method: method,
        url: url,
        data: data,
        headers
    });
}
